export enum HealthcareSubSector {
  BIOPHARMACEUTICALS = 'BIOPHARMACEUTICALS',
  MED_TECH = 'MED_TECH',
  DIAGNOSTICS = 'DIAGNOSTICS',
  LAB_TECHNOLOGY = 'LAB_TECHNOLOGY',
  PHARMA_SERVICES = 'PHARMA_SERVICES',
  HCIT = 'HCIT',
  TECH_ENABLED_SERVICES = 'TECH_ENABLED_SERVICES',
  VBC = 'VBC',
  CARE_PROVIDER = 'CARE_PROVIDER',
}

export const HealthcareSubSectorLabels: Record<HealthcareSubSector, string> = {
  [HealthcareSubSector.BIOPHARMACEUTICALS]: 'Biopharmaceuticals',
  [HealthcareSubSector.MED_TECH]: 'MedTech',
  [HealthcareSubSector.DIAGNOSTICS]: 'Diagnostics',
  [HealthcareSubSector.LAB_TECHNOLOGY]: 'Lab Technology/Tools',
  [HealthcareSubSector.PHARMA_SERVICES]: 'Pharma Services',
  [HealthcareSubSector.HCIT]: 'HCIT',
  [HealthcareSubSector.TECH_ENABLED_SERVICES]: 'Tech-Enabled Services',
  [HealthcareSubSector.VBC]: 'VBC',
  [HealthcareSubSector.CARE_PROVIDER]: 'Care Provider',
};
